import { render } from "./RobosFilas.vue?vue&type=template&id=1345c7b7&scoped=true"
import script from "./RobosFilas.vue?vue&type=script&lang=ts"
export * from "./RobosFilas.vue?vue&type=script&lang=ts"

import "./RobosFilas.vue?vue&type=style&index=0&id=1345c7b7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1345c7b7"

export default script